import React from 'react';
import * as RadixPopover from '@radix-ui/react-popover';
import classNames from 'classnames';

import { CrossIcon } from '../../assets';
import { Button } from '../Button';
import { Card } from '../Card';
import { Typography } from '../Typography';

import styles from './Popover.module.scss';

export interface IPopoverProps extends RadixPopover.PopoverProps {
    label?: string;
    trigger: React.ReactNode;
    triggerClassName?: string;
    contentProps?: RadixPopover.PopoverContentProps;
}

export const Popover: React.FC<IPopoverProps> = ({
    label,
    trigger,
    triggerClassName,
    contentProps,
    children,
    ...props
}) => {
    return (
        <RadixPopover.Root {...props}>
            <RadixPopover.Trigger asChild>
                <button className={classNames(styles.trigger, triggerClassName)} aria-label={label}>
                    {trigger}
                </button>
            </RadixPopover.Trigger>
            <RadixPopover.Portal>
                <RadixPopover.Content asChild className={styles.content} {...contentProps}>
                    <Card shadow="medium" rounded="small" size="small" gap={0}>
                        <RadixPopover.Arrow className={styles.arrow} />
                        {label && (
                            <div className={styles.header}>
                                <Typography fontWeight="semibold">{label}</Typography>
                                <RadixPopover.Close aria-label="Close" asChild>
                                    <Button variant="fab" color="transparent" rounded="full" size="small">
                                        <CrossIcon />
                                    </Button>
                                </RadixPopover.Close>
                            </div>
                        )}
                        {children}
                    </Card>
                </RadixPopover.Content>
            </RadixPopover.Portal>
        </RadixPopover.Root>
    );
};
